interface IFieldManifest<TValue> {
    [id: string]: TValue
}

const fieldManifest: IFieldManifest<number> = {
    Account: 1,
    AccountType: 581,
    AccruedInterestAmt: 159,
    AccruedInterestRate: 158,
    AcctIDSource: 660,
    Adjustment: 334,
    AdjustmentType: 718,
    AdvId: 2,
    AdvRefID: 3,
    AdvSide: 4,
    AdvTransType: 5,
    AffectedOrderID: 535,
    AffectedSecondaryOrderID: 536,
    AffirmStatus: 940,
    AggregatedBook: 266,
    AggressorIndicator: 1057,
    AgreementCurrency: 918,
    AgreementDate: 915,
    AgreementDesc: 913,
    AgreementID: 914,
    AllocAccount: 79,
    AllocAccountType: 798,
    AllocAccruedInterestAmt: 742,
    AllocAcctIDSource: 661,
    AllocAvgPx: 153,
    AllocCancReplaceReason: 796,
    AllocClearingFeeIndicator: 1136,
    AllocCustomerCapacity: 993,
    AllocHandlInst: 209,
    AllocID: 70,
    AllocInterestAtMaturity: 741,
    AllocIntermedReqType: 808,
    AllocLinkID: 196,
    AllocLinkType: 197,
    AllocMethod: 1002,
    AllocNetMoney: 154,
    AllocNoOrdersType: 857,
    AllocPositionEffect: 1047,
    AllocPrice: 366,
    AllocQty: 80,
    AllocRejCode: 88,
    AllocReportID: 755,
    AllocReportRefID: 795,
    AllocReportType: 794,
    AllocSettlCurrAmt: 737,
    AllocSettlCurrency: 736,
    AllocSettlInstType: 780,
    AllocStatus: 87,
    AllocText: 161,
    AllocTransType: 71,
    AllocType: 626,
    AllowableOneSidednessCurr: 767,
    AllowableOneSidednessPct: 765,
    AllowableOneSidednessValue: 766,
    AltMDSourceID: 817,
    ApplBegSeqNum: 1182,
    ApplEndSeqNum: 1183,
    ApplID: 1180,
    ApplLastSeqNum: 1350,
    ApplNewSeqNum: 1399,
    ApplQueueAction: 815,
    ApplQueueDepth: 813,
    ApplQueueMax: 812,
    ApplQueueResolution: 814,
    ApplReportID: 1356,
    ApplReportType: 1426,
    ApplReqID: 1346,
    ApplReqType: 1347,
    ApplResendFlag: 1352,
    ApplResponseError: 1354,
    ApplResponseID: 1353,
    ApplResponseType: 1348,
    ApplSeqNum: 1181,
    ApplTotalMessageCount: 1349,
    ApplVerID: 1128,
    AsOfIndicator: 1015,
    AsgnRptID: 833,
    AssignmentMethod: 744,
    AssignmentUnit: 745,
    AttachmentPoint: 1457,
    AutoAcceptIndicator: 754,
    AvgParPx: 860,
    AvgPx: 6,
    AvgPxIndicator: 819,
    AvgPxPrecision: 74,
    BasisFeatureDate: 259,
    BasisFeaturePrice: 260,
    BasisPxType: 419,
    BeginSeqNo: 7,
    BeginString: 8,
    BenchmarkCurveCurrency: 220,
    BenchmarkCurveName: 221,
    BenchmarkCurvePoint: 222,
    BenchmarkPrice: 662,
    BenchmarkPriceType: 663,
    BenchmarkSecurityID: 699,
    BenchmarkSecurityIDSource: 761,
    BidDescriptor: 400,
    BidDescriptorType: 399,
    BidForwardPoints: 189,
    BidForwardPoints2: 642,
    BidID: 390,
    BidPx: 132,
    BidRequestTransType: 374,
    BidSize: 134,
    BidSpotRate: 188,
    BidSwapPoints: 1065,
    BidTradeType: 418,
    BidType: 394,
    BidYield: 632,
    BodyLength: 9,
    BookingRefID: 466,
    BookingType: 775,
    BookingUnit: 590,
    BusinessRejectReason: 380,
    BusinessRejectRefID: 379,
    BuyVolume: 330,
    CFICode: 461,
    CPProgram: 875,
    CPRegType: 876,
    CalculatedCcyLastQty: 1056,
    CancellationRights: 480,
    CapPrice: 1199,
    CardExpDate: 490,
    CardHolderName: 488,
    CardIssNum: 491,
    CardNumber: 489,
    CardStartDate: 503,
    CashDistribAgentAcctName: 502,
    CashDistribAgentAcctNumber: 500,
    CashDistribAgentCode: 499,
    CashDistribAgentName: 498,
    CashDistribCurr: 478,
    CashDistribPayRef: 501,
    CashMargin: 544,
    CashOrderQty: 152,
    CashOutstanding: 901,
    CcyAmt: 1157,
    CheckSum: 10,
    ClOrdID: 11,
    ClOrdLinkID: 583,
    ClearingBusinessDate: 715,
    ClearingFeeIndicator: 635,
    ClearingInstruction: 577,
    ClientBidID: 391,
    CollAction: 944,
    CollApplType: 1043,
    CollAsgnID: 902,
    CollAsgnReason: 895,
    CollAsgnRefID: 907,
    CollAsgnRejectReason: 906,
    CollAsgnRespType: 905,
    CollAsgnTransType: 903,
    CollInquiryID: 909,
    CollInquiryQualifier: 896,
    CollInquiryResult: 946,
    CollInquiryStatus: 945,
    CollReqID: 894,
    CollRespID: 904,
    CollRptID: 908,
    CollStatus: 910,
    CommCurrency: 479,
    CommType: 13,
    Commission: 12,
    ComplexEventCondition: 1490,
    ComplexEventEndDate: 1493,
    ComplexEventEndTime: 1496,
    ComplexEventPrice: 1486,
    ComplexEventPriceBoundaryMethod: 1487,
    ComplexEventPriceBoundaryPrecision: 1488,
    ComplexEventPriceTimeType: 1489,
    ComplexEventStartDate: 1492,
    ComplexEventStartTime: 1495,
    ComplexEventType: 1484,
    ComplexOptPayoutAmount: 1485,
    ComplianceID: 376,
    Concession: 238,
    ConfirmID: 664,
    ConfirmRefID: 772,
    ConfirmRejReason: 774,
    ConfirmReqID: 859,
    ConfirmStatus: 665,
    ConfirmTransType: 666,
    ConfirmType: 773,
    ContAmtCurr: 521,
    ContAmtType: 519,
    ContAmtValue: 520,
    ContIntRptID: 977,
    ContingencyType: 1385,
    ContraBroker: 375,
    ContraLegRefID: 655,
    ContraTradeQty: 437,
    ContraTradeTime: 438,
    ContraTrader: 337,
    ContractMultiplier: 231,
    ContractMultiplierUnit: 1435,
    ContractSettlMonth: 667,
    ContraryInstructionIndicator: 719,
    CopyMsgIndicator: 797,
    CorporateAction: 292,
    Country: 421,
    CountryOfIssue: 470,
    CouponPaymentDate: 224,
    CouponRate: 223,
    CoveredOrUncovered: 203,
    CreditRating: 255,
    CrossID: 548,
    CrossPercent: 413,
    CrossPrioritization: 550,
    CrossType: 549,
    CstmApplVerID: 1129,
    CumQty: 14,
    Currency: 15,
    CurrencyRatio: 1382,
    CustDirectedOrder: 1029,
    CustOrderCapacity: 582,
    CustOrderHandlingInst: 1031,
    CxlQty: 84,
    CxlRejReason: 102,
    CxlRejResponseTo: 434,
    DKReason: 127,
    DateOfBirth: 486,
    DatedDate: 873,
    DayAvgPx: 426,
    DayBookingInst: 589,
    DayCumQty: 425,
    DayOrderQty: 424,
    DealingCapacity: 1048,
    DefBidSize: 293,
    DefOfferSize: 294,
    DefaultApplVerID: 1137,
    DefaultVerIndicator: 1410,
    DeleteReason: 285,
    DeliverToCompID: 128,
    DeliverToLocationID: 145,
    DeliverToSubID: 129,
    DeliveryDate: 743,
    DeliveryForm: 668,
    DeliveryType: 919,
    DerivFlexProductEligibilityIndicator: 1243,
    DerivativeCFICode: 1248,
    DerivativeCapPrice: 1321,
    DerivativeContractMultiplier: 1266,
    DerivativeContractMultiplierUnit: 1438,
    DerivativeContractSettlMonth: 1285,
    DerivativeCountryOfIssue: 1258,
    DerivativeEncodedIssuer: 1278,
    DerivativeEncodedIssuerLen: 1277,
    DerivativeEncodedSecurityDesc: 1281,
    DerivativeEncodedSecurityDescLen: 1280,
    DerivativeEventDate: 1288,
    DerivativeEventPx: 1290,
    DerivativeEventText: 1291,
    DerivativeEventTime: 1289,
    DerivativeEventType: 1287,
    DerivativeExerciseStyle: 1299,
    DerivativeFloorPrice: 1322,
    DerivativeFlowScheduleType: 1442,
    DerivativeInstrAttribType: 1313,
    DerivativeInstrAttribValue: 1314,
    DerivativeInstrRegistry: 1257,
    DerivativeInstrmtAssignmentMethod: 1255,
    DerivativeInstrumentPartyID: 1293,
    DerivativeInstrumentPartyIDSource: 1294,
    DerivativeInstrumentPartyRole: 1295,
    DerivativeInstrumentPartySubID: 1297,
    DerivativeInstrumentPartySubIDType: 1298,
    DerivativeIssueDate: 1276,
    DerivativeIssuer: 1275,
    DerivativeListMethod: 1320,
    DerivativeLocaleOfIssue: 1260,
    DerivativeMaturityDate: 1252,
    DerivativeMaturityMonthYear: 1251,
    DerivativeMaturityTime: 1253,
    DerivativeMinPriceIncrement: 1267,
    DerivativeMinPriceIncrementAmount: 1268,
    DerivativeNTPositionLimit: 1274,
    DerivativeOptAttribute: 1265,
    DerivativeOptPayAmount: 1225,
    DerivativePositionLimit: 1273,
    DerivativePriceQuoteMethod: 1318,
    DerivativePriceUnitOfMeasure: 1315,
    DerivativePriceUnitOfMeasureQty: 1316,
    DerivativeProduct: 1246,
    DerivativeProductComplex: 1228,
    DerivativePutOrCall: 1323,
    DerivativeSecurityAltID: 1219,
    DerivativeSecurityAltIDSource: 1220,
    DerivativeSecurityDesc: 1279,
    DerivativeSecurityExchange: 1272,
    DerivativeSecurityGroup: 1247,
    DerivativeSecurityID: 1216,
    DerivativeSecurityIDSource: 1217,
    DerivativeSecurityStatus: 1256,
    DerivativeSecuritySubType: 1250,
    DerivativeSecurityType: 1249,
    DerivativeSecurityXML: 1283,
    DerivativeSecurityXMLLen: 1282,
    DerivativeSecurityXMLSchema: 1284,
    DerivativeSettlMethod: 1317,
    DerivativeSettleOnOpenFlag: 1254,
    DerivativeStateOrProvinceOfIssue: 1259,
    DerivativeStrikeCurrency: 1262,
    DerivativeStrikeMultiplier: 1263,
    DerivativeStrikePrice: 1261,
    DerivativeStrikeValue: 1264,
    DerivativeSymbol: 1214,
    DerivativeSymbolSfx: 1215,
    DerivativeTimeUnit: 1271,
    DerivativeUnitOfMeasure: 1269,
    DerivativeUnitOfMeasureQty: 1270,
    DerivativeValuationMethod: 1319,
    Designation: 494,
    DeskID: 284,
    DeskOrderHandlingInst: 1035,
    DeskType: 1033,
    DeskTypeSource: 1034,
    DetachmentPoint: 1458,
    DiscretionInst: 388,
    DiscretionLimitType: 843,
    DiscretionMoveType: 841,
    DiscretionOffsetType: 842,
    DiscretionOffsetValue: 389,
    DiscretionPrice: 845,
    DiscretionRoundDirection: 844,
    DiscretionScope: 846,
    DisplayHighQty: 1086,
    DisplayLowQty: 1085,
    DisplayMethod: 1084,
    DisplayMinIncr: 1087,
    DisplayQty: 1138,
    DisplayWhen: 1083,
    DistribPaymentMethod: 477,
    DistribPercentage: 512,
    DividendYield: 1380,
    DlvyInstType: 787,
    DueToRelated: 329,
    EFPTrackingError: 405,
    EffectiveTime: 168,
    EmailThreadID: 164,
    EmailType: 94,
    EncodedAllocText: 361,
    EncodedAllocTextLen: 360,
    EncodedHeadline: 359,
    EncodedHeadlineLen: 358,
    EncodedIssuer: 349,
    EncodedIssuerLen: 348,
    EncodedLegIssuer: 619,
    EncodedLegIssuerLen: 618,
    EncodedLegSecurityDesc: 622,
    EncodedLegSecurityDescLen: 621,
    EncodedListExecInst: 353,
    EncodedListExecInstLen: 352,
    EncodedListStatusText: 446,
    EncodedListStatusTextLen: 445,
    EncodedMktSegmDesc: 1398,
    EncodedMktSegmDescLen: 1397,
    EncodedSecurityDesc: 351,
    EncodedSecurityDescLen: 350,
    EncodedSecurityListDesc: 1469,
    EncodedSecurityListDescLen: 1468,
    EncodedSubject: 357,
    EncodedSubjectLen: 356,
    EncodedText: 355,
    EncodedTextLen: 354,
    EncodedUnderlyingIssuer: 363,
    EncodedUnderlyingIssuerLen: 362,
    EncodedUnderlyingSecurityDesc: 365,
    EncodedUnderlyingSecurityDescLen: 364,
    EncryptMethod: 98,
    EncryptedNewPassword: 1404,
    EncryptedNewPasswordLen: 1403,
    EncryptedPassword: 1402,
    EncryptedPasswordLen: 1401,
    EncryptedPasswordMethod: 1400,
    EndAccruedInterestAmt: 920,
    EndCash: 922,
    EndDate: 917,
    EndMaturityMonthYear: 1226,
    EndSeqNo: 16,
    EndStrikePxRange: 1203,
    EndTickPriceRange: 1207,
    EventDate: 866,
    EventPx: 867,
    EventText: 868,
    EventTime: 1145,
    EventType: 865,
    ExDate: 230,
    ExDestination: 100,
    ExDestinationIDSource: 1133,
    ExchangeForPhysical: 411,
    ExchangeRule: 825,
    ExchangeSpecialInstructions: 1139,
    ExecAckStatus: 1036,
    ExecID: 17,
    ExecInst: 18,
    ExecInstValue: 1308,
    ExecPriceAdjustment: 485,
    ExecPriceType: 484,
    ExecRefID: 19,
    ExecRestatementReason: 378,
    ExecType: 150,
    ExecValuationPoint: 515,
    ExerciseMethod: 747,
    ExerciseStyle: 1194,
    ExpQty: 983,
    ExpirationCycle: 827,
    ExpirationQtyType: 982,
    ExpireDate: 432,
    ExpireTime: 126,
    Factor: 228,
    FairValue: 406,
    FeeMultiplier: 1329,
    FillExecID: 1363,
    FillLiquidityInd: 1443,
    FillPx: 1364,
    FillQty: 1365,
    FinancialStatus: 291,
    FirmTradeID: 1041,
    FirstPx: 1025,
    FlexProductEligibilityIndicator: 1242,
    FlexibleIndicator: 1244,
    FloorPrice: 1200,
    FlowScheduleType: 1439,
    ForexReq: 121,
    FundRenewWaiv: 497,
    GTBookingInst: 427,
    GapFillFlag: 123,
    GrossTradeAmt: 381,
    HaltReasonInt: 327,
    HandlInst: 21,
    Headline: 148,
    HeartBtInt: 108,
    HighLimitPrice: 1149,
    HighPx: 332,
    HopCompID: 628,
    HopRefID: 630,
    HopSendingTime: 629,
    HostCrossID: 961,
    IOIID: 23,
    IOINaturalFlag: 130,
    IOIQltyInd: 25,
    IOIQty: 27,
    IOIQualifier: 104,
    IOIRefID: 26,
    IOITransType: 28,
    ImpliedMarketIndicator: 1144,
    InViewOfCommon: 328,
    IncTaxInd: 416,
    IndividualAllocID: 467,
    IndividualAllocRejCode: 776,
    IndividualAllocType: 992,
    InputSource: 979,
    InstrAttribType: 871,
    InstrAttribValue: 872,
    InstrRegistry: 543,
    InstrmtAssignmentMethod: 1049,
    InstrumentPartyID: 1019,
    InstrumentPartyIDSource: 1050,
    InstrumentPartyRole: 1051,
    InstrumentPartySubID: 1053,
    InstrumentPartySubIDType: 1054,
    InterestAccrualDate: 874,
    InterestAtMaturity: 738,
    InvestorCountryOfResidence: 475,
    IssueDate: 225,
    Issuer: 106,
    LanguageCode: 1474,
    LastCapacity: 29,
    LastForwardPoints: 195,
    LastForwardPoints2: 641,
    LastFragment: 893,
    LastLiquidityInd: 851,
    LastMkt: 30,
    LastMsgSeqNumProcessed: 369,
    LastNetworkResponseID: 934,
    LastParPx: 669,
    LastPx: 31,
    LastQty: 32,
    LastRptRequested: 912,
    LastSpotRate: 194,
    LastSwapPoints: 1071,
    LastUpdateTime: 779,
    LateIndicator: 978,
    LeavesQty: 151,
    LegAllocAccount: 671,
    LegAllocAcctIDSource: 674,
    LegAllocID: 1366,
    LegAllocQty: 673,
    LegAllocSettlCurrency: 1367,
    LegBenchmarkCurveCurrency: 676,
    LegBenchmarkCurveName: 677,
    LegBenchmarkCurvePoint: 678,
    LegBenchmarkPrice: 679,
    LegBenchmarkPriceType: 680,
    LegBidForwardPoints: 1067,
    LegBidPx: 681,
    LegCFICode: 608,
    LegCalculatedCcyLastQty: 1074,
    LegContractMultiplier: 614,
    LegContractMultiplierUnit: 1436,
    LegContractSettlMonth: 955,
    LegCountryOfIssue: 596,
    LegCouponPaymentDate: 248,
    LegCouponRate: 615,
    LegCoveredOrUncovered: 565,
    LegCreditRating: 257,
    LegCurrency: 556,
    LegCurrencyRatio: 1383,
    LegDatedDate: 739,
    LegDividendYield: 1381,
    LegExecInst: 1384,
    LegExerciseStyle: 1420,
    LegFactor: 253,
    LegFlowScheduleType: 1440,
    LegGrossTradeAmt: 1075,
    LegIOIQty: 682,
    LegIndividualAllocID: 672,
    LegInstrRegistry: 599,
    LegInterestAccrualDate: 956,
    LegIssueDate: 249,
    LegIssuer: 617,
    LegLastForwardPoints: 1073,
    LegLastPx: 637,
    LegLastQty: 1418,
    LegLocaleOfIssue: 598,
    LegMaturityDate: 611,
    LegMaturityMonthYear: 610,
    LegMaturityTime: 1212,
    LegNumber: 1152,
    LegOfferForwardPoints: 1068,
    LegOfferPx: 684,
    LegOptAttribute: 613,
    LegOptionRatio: 1017,
    LegOrderQty: 685,
    LegPool: 740,
    LegPositionEffect: 564,
    LegPriceType: 686,
    LegPriceUnitOfMeasure: 1421,
    LegPriceUnitOfMeasureQty: 1422,
    LegProduct: 607,
    LegPutOrCall: 1358,
    LegQty: 687,
    LegRatioQty: 623,
    LegRedemptionDate: 254,
    LegRefID: 654,
    LegRepoCollateralSecurityType: 250,
    LegReportID: 990,
    LegRepurchaseRate: 252,
    LegRepurchaseTerm: 251,
    LegSecurityAltID: 605,
    LegSecurityAltIDSource: 606,
    LegSecurityDesc: 620,
    LegSecurityExchange: 616,
    LegSecurityID: 602,
    LegSecurityIDSource: 603,
    LegSecuritySubType: 764,
    LegSecurityType: 609,
    LegSettlCurrency: 675,
    LegSettlDate: 588,
    LegSettlType: 587,
    LegSide: 624,
    LegStateOrProvinceOfIssue: 597,
    LegStipulationType: 688,
    LegStipulationValue: 689,
    LegStrikeCurrency: 942,
    LegStrikePrice: 612,
    LegSwapType: 690,
    LegSymbol: 600,
    LegSymbolSfx: 601,
    LegTimeUnit: 1001,
    LegUnitOfMeasure: 999,
    LegUnitOfMeasureQty: 1224,
    LegVolatility: 1379,
    LegalConfirm: 650,
    LiquidityIndType: 409,
    LiquidityNumSecurities: 441,
    LiquidityPctHigh: 403,
    LiquidityPctLow: 402,
    LiquidityValue: 404,
    ListExecInst: 69,
    ListExecInstType: 433,
    ListID: 66,
    ListMethod: 1198,
    ListName: 392,
    ListOrderStatus: 431,
    ListRejectReason: 1386,
    ListSeqNo: 67,
    ListStatusText: 444,
    ListStatusType: 429,
    ListUpdateAction: 1324,
    LocaleOfIssue: 472,
    LocateReqd: 114,
    LocationID: 283,
    LongQty: 704,
    LotType: 1093,
    LowLimitPrice: 1148,
    LowPx: 333,
    MDBookType: 1021,
    MDEntryBuyer: 288,
    MDEntryDate: 272,
    MDEntryForwardPoints: 1027,
    MDEntryID: 278,
    MDEntryOriginator: 282,
    MDEntryPositionNo: 290,
    MDEntryPx: 270,
    MDEntryRefID: 280,
    MDEntrySeller: 289,
    MDEntrySize: 271,
    MDEntrySpotRate: 1026,
    MDEntryTime: 273,
    MDEntryType: 269,
    MDFeedType: 1022,
    MDImplicitDelete: 547,
    MDMkt: 275,
    MDOriginType: 1024,
    MDPriceLevel: 1023,
    MDQuoteType: 1070,
    MDReportID: 963,
    MDReqID: 262,
    MDReqRejReason: 281,
    MDSecSize: 1179,
    MDSecSizeType: 1178,
    MDStreamID: 1500,
    MDSubBookType: 1173,
    MDUpdateAction: 279,
    MDUpdateType: 265,
    MailingDtls: 474,
    MailingInst: 482,
    ManualOrderIndicator: 1028,
    MarginExcess: 899,
    MarginRatio: 898,
    MarketDepth: 264,
    MarketID: 1301,
    MarketReportID: 1394,
    MarketReqID: 1393,
    MarketSegmentDesc: 1396,
    MarketSegmentID: 1300,
    MarketUpdateAction: 1395,
    MassActionRejectReason: 1376,
    MassActionReportID: 1369,
    MassActionResponse: 1375,
    MassActionScope: 1374,
    MassActionType: 1373,
    MassCancelRejectReason: 532,
    MassCancelRequestType: 530,
    MassCancelResponse: 531,
    MassStatusReqID: 584,
    MassStatusReqType: 585,
    MatchAlgorithm: 1142,
    MatchIncrement: 1089,
    MatchStatus: 573,
    MatchType: 574,
    MaturityDate: 541,
    MaturityMonthYear: 200,
    MaturityMonthYearFormat: 1303,
    MaturityMonthYearIncrement: 1229,
    MaturityMonthYearIncrementUnits: 1302,
    MaturityNetMoney: 890,
    MaturityRuleID: 1222,
    MaturityTime: 1079,
    MaxFloor: 111,
    MaxMessageSize: 383,
    MaxPriceLevels: 1090,
    MaxPriceVariation: 1143,
    MaxShow: 210,
    MaxTradeVol: 1140,
    MessageEncoding: 347,
    MessageEventSource: 1011,
    MidPx: 631,
    MidYield: 633,
    MinBidSize: 647,
    MinLotSize: 1231,
    MinOfferSize: 648,
    MinPriceIncrement: 969,
    MinPriceIncrementAmount: 1146,
    MinQty: 110,
    MinTradeVol: 562,
    MiscFeeAmt: 137,
    MiscFeeBasis: 891,
    MiscFeeCurr: 138,
    MiscFeeType: 139,
    MktBidPx: 645,
    MktOfferPx: 646,
    ModelType: 1434,
    MoneyLaunderingStatus: 481,
    MsgDirection: 385,
    MsgSeqNum: 34,
    MsgType: 35,
    MultiLegReportingType: 442,
    MultiLegRptTypeReq: 563,
    MultilegModel: 1377,
    MultilegPriceMethod: 1378,
    NTPositionLimit: 971,
    Nested2PartyID: 757,
    Nested2PartyIDSource: 758,
    Nested2PartyRole: 759,
    Nested2PartySubID: 760,
    Nested2PartySubIDType: 807,
    Nested3PartyID: 949,
    Nested3PartyIDSource: 950,
    Nested3PartyRole: 951,
    Nested3PartySubID: 953,
    Nested3PartySubIDType: 954,
    Nested4PartyID: 1415,
    Nested4PartyIDSource: 1416,
    Nested4PartyRole: 1417,
    Nested4PartySubID: 1412,
    Nested4PartySubIDType: 1411,
    NestedInstrAttribType: 1210,
    NestedInstrAttribValue: 1211,
    NestedPartyID: 524,
    NestedPartyIDSource: 525,
    NestedPartyRole: 538,
    NestedPartySubID: 545,
    NestedPartySubIDType: 805,
    NetChgPrevDay: 451,
    NetGrossInd: 430,
    NetMoney: 118,
    NetworkRequestID: 933,
    NetworkRequestType: 935,
    NetworkResponseID: 932,
    NetworkStatusResponseType: 937,
    NewPassword: 925,
    NewSeqNo: 36,
    NewsCategory: 1473,
    NewsID: 1472,
    NewsRefID: 1476,
    NewsRefType: 1477,
    NextExpectedMsgSeqNum: 789,
    NoAffectedOrders: 534,
    NoAllocs: 78,
    NoAltMDSource: 816,
    NoApplIDs: 1351,
    NoAsgnReqs: 1499,
    NoBidComponents: 420,
    NoBidDescriptors: 398,
    NoCapacities: 862,
    NoClearingInstructions: 576,
    NoCollInquiryQualifier: 938,
    NoCompIDs: 936,
    NoComplexEventDates: 1491,
    NoComplexEventTimes: 1494,
    NoComplexEvents: 1483,
    NoContAmts: 518,
    NoContraBrokers: 382,
    NoDates: 580,
    NoDerivativeEvents: 1286,
    NoDerivativeInstrAttrib: 1311,
    NoDerivativeInstrumentParties: 1292,
    NoDerivativeInstrumentPartySubIDs: 1296,
    NoDerivativeSecurityAltID: 1218,
    NoDistribInsts: 510,
    NoDlvyInst: 85,
    NoEvents: 864,
    NoExecInstRules: 1232,
    NoExecs: 124,
    NoExpiration: 981,
    NoFills: 1362,
    NoHops: 627,
    NoIOIQualifiers: 199,
    NoInstrAttrib: 870,
    NoInstrumentParties: 1018,
    NoInstrumentPartySubIDs: 1052,
    NoLegAllocs: 670,
    NoLegSecurityAltID: 604,
    NoLegStipulations: 683,
    NoLegs: 555,
    NoLinesOfText: 33,
    NoLotTypeRules: 1234,
    NoMDEntries: 268,
    NoMDEntryTypes: 267,
    NoMDFeedTypes: 1141,
    NoMarketSegments: 1310,
    NoMatchRules: 1235,
    NoMaturityRules: 1236,
    NoMiscFees: 136,
    NoMsgTypes: 384,
    NoNested2PartyIDs: 756,
    NoNested2PartySubIDs: 806,
    NoNested3PartyIDs: 948,
    NoNested3PartySubIDs: 952,
    NoNested4PartyIDs: 1414,
    NoNested4PartySubIDs: 1413,
    NoNestedInstrAttrib: 1312,
    NoNestedPartyIDs: 539,
    NoNestedPartySubIDs: 804,
    NoNewsRefIDs: 1475,
    NoNotAffectedOrders: 1370,
    NoOfLegUnderlyings: 1342,
    NoOfSecSizes: 1177,
    NoOrdTypeRules: 1237,
    NoOrders: 73,
    NoPartyIDs: 453,
    NoPartySubIDs: 802,
    NoPosAmt: 753,
    NoPositions: 702,
    NoQuoteEntries: 295,
    NoQuoteQualifiers: 735,
    NoQuoteSets: 296,
    NoRateSources: 1445,
    NoRegistDtls: 473,
    NoRelatedSym: 146,
    NoRootPartyIDs: 1116,
    NoRootPartySubIDs: 1120,
    NoRoutingIDs: 215,
    NoRpts: 82,
    NoSecurityAltID: 454,
    NoSecurityTypes: 558,
    NoSettlDetails: 1158,
    NoSettlInst: 778,
    NoSettlOblig: 1165,
    NoSettlPartyIDs: 781,
    NoSettlPartySubIDs: 801,
    NoSideTrdRegTS: 1016,
    NoSides: 552,
    NoStatsIndicators: 1175,
    NoStipulations: 232,
    NoStrategyParameters: 957,
    NoStrikeRules: 1201,
    NoStrikes: 428,
    NoTargetPartyIDs: 1461,
    NoTickRules: 1205,
    NoTimeInForceRules: 1239,
    NoTrades: 897,
    NoTradingSessionRules: 1309,
    NoTradingSessions: 386,
    NoTrdRegTimestamps: 768,
    NoTrdRepIndicators: 1387,
    NoUnderlyingAmounts: 984,
    NoUnderlyingLegSecurityAltID: 1334,
    NoUnderlyingSecurityAltID: 457,
    NoUnderlyingStips: 887,
    NoUnderlyings: 711,
    NoUndlyInstrumentParties: 1058,
    NoUndlyInstrumentPartySubIDs: 1062,
    NoUsernames: 809,
    NotAffOrigClOrdID: 1372,
    NotAffectedOrderID: 1371,
    NotifyBrokerOfCredit: 208,
    NotionalPercentageOutstanding: 1451,
    NumBidders: 417,
    NumDaysInterest: 157,
    NumTickets: 395,
    NumberOfOrders: 346,
    OddLot: 575,
    OfferForwardPoints: 191,
    OfferForwardPoints2: 643,
    OfferPx: 133,
    OfferSize: 135,
    OfferSpotRate: 190,
    OfferSwapPoints: 1066,
    OfferYield: 634,
    OnBehalfOfCompID: 115,
    OnBehalfOfLocationID: 144,
    OnBehalfOfSubID: 116,
    OpenCloseSettlFlag: 286,
    OpenInterest: 746,
    OptAttribute: 206,
    OptPayoutAmount: 1195,
    OptPayoutType: 1482,
    OrdRejReason: 103,
    OrdStatus: 39,
    OrdStatusReqID: 790,
    OrdType: 40,
    OrderAvgPx: 799,
    OrderBookingQty: 800,
    OrderCapacity: 528,
    OrderCapacityQty: 863,
    OrderCategory: 1115,
    OrderDelay: 1428,
    OrderDelayUnit: 1429,
    OrderHandlingInstSource: 1032,
    OrderID: 37,
    OrderInputDevice: 821,
    OrderPercent: 516,
    OrderQty: 38,
    OrderQty2: 192,
    OrderRestrictions: 529,
    OrigClOrdID: 41,
    OrigCrossID: 551,
    OrigCustOrderCapacity: 1432,
    OrigOrdModTime: 586,
    OrigPosReqRefID: 713,
    OrigSecondaryTradeID: 1127,
    OrigSendingTime: 122,
    OrigTime: 42,
    OrigTradeDate: 1125,
    OrigTradeHandlingInstr: 1124,
    OrigTradeID: 1126,
    OriginalNotionalPercentageOutstanding: 1452,
    OutMainCntryUIndex: 412,
    OutsideIndexPct: 407,
    OwnerType: 522,
    OwnershipType: 517,
    ParentMktSegmID: 1325,
    ParticipationRate: 849,
    PartyID: 448,
    PartyIDSource: 447,
    PartyRole: 452,
    PartySubID: 523,
    PartySubIDType: 803,
    Password: 554,
    PaymentDate: 504,
    PaymentMethod: 492,
    PaymentRef: 476,
    PaymentRemitterID: 505,
    PctAtRisk: 869,
    PegLimitType: 837,
    PegMoveType: 835,
    PegOffsetType: 836,
    PegOffsetValue: 211,
    PegPriceType: 1094,
    PegRoundDirection: 838,
    PegScope: 840,
    PegSecurityDesc: 1099,
    PegSecurityID: 1097,
    PegSecurityIDSource: 1096,
    PegSymbol: 1098,
    PeggedPrice: 839,
    PeggedRefPrice: 1095,
    Pool: 691,
    PosAmt: 708,
    PosAmtType: 707,
    PosMaintAction: 712,
    PosMaintResult: 723,
    PosMaintRptID: 721,
    PosMaintRptRefID: 714,
    PosMaintStatus: 722,
    PosQtyStatus: 706,
    PosReqID: 710,
    PosReqResult: 728,
    PosReqStatus: 729,
    PosReqType: 724,
    PosTransType: 709,
    PosType: 703,
    PositionCurrency: 1055,
    PositionEffect: 77,
    PositionLimit: 970,
    PossDupFlag: 43,
    PossResend: 97,
    PreTradeAnonymity: 1091,
    PreallocMethod: 591,
    PrevClosePx: 140,
    PreviouslyReported: 570,
    Price: 44,
    Price2: 640,
    PriceDelta: 811,
    PriceImprovement: 639,
    PriceLimitType: 1306,
    PriceProtectionScope: 1092,
    PriceQuoteMethod: 1196,
    PriceType: 423,
    PriceUnitOfMeasure: 1191,
    PriceUnitOfMeasureQty: 1192,
    PriorSettlPrice: 734,
    PriorSpreadIndicator: 720,
    PriorityIndicator: 638,
    PrivateQuote: 1171,
    ProcessCode: 81,
    Product: 460,
    ProductComplex: 1227,
    ProgPeriodInterval: 415,
    ProgRptReqs: 414,
    PublishTrdIndicator: 852,
    PutOrCall: 201,
    QtyType: 854,
    Quantity: 53,
    QuantityDate: 976,
    QuoteCancelType: 298,
    QuoteCondition: 276,
    QuoteEntryID: 299,
    QuoteEntryRejectReason: 368,
    QuoteEntryStatus: 1167,
    QuoteID: 117,
    QuoteMsgID: 1166,
    QuotePriceType: 692,
    QuoteQualifier: 695,
    QuoteRejectReason: 300,
    QuoteReqID: 131,
    QuoteRequestRejectReason: 658,
    QuoteRequestType: 303,
    QuoteRespID: 693,
    QuoteRespType: 694,
    QuoteResponseLevel: 301,
    QuoteSetID: 302,
    QuoteSetValidUntilTime: 367,
    QuoteStatus: 297,
    QuoteStatusReqID: 649,
    QuoteType: 537,
    RFQReqID: 644,
    RateSource: 1446,
    RateSourceType: 1447,
    RawData: 96,
    RawDataLength: 95,
    ReceivedDeptID: 1030,
    RedemptionDate: 240,
    RefAllocID: 72,
    RefApplExtID: 1406,
    RefApplID: 1355,
    RefApplLastSeqNum: 1357,
    RefApplReqID: 1433,
    RefApplVerID: 1130,
    RefCompID: 930,
    RefCstmApplVerID: 1131,
    RefMsgType: 372,
    RefOrdIDReason: 1431,
    RefOrderID: 1080,
    RefOrderIDSource: 1081,
    RefSeqNum: 45,
    RefSubID: 931,
    RefTagID: 371,
    ReferencePage: 1448,
    RefreshIndicator: 1187,
    RefreshQty: 1088,
    RegistAcctType: 493,
    RegistDtls: 509,
    RegistEmail: 511,
    RegistID: 513,
    RegistRefID: 508,
    RegistRejReasonCode: 507,
    RegistRejReasonText: 496,
    RegistStatus: 506,
    RegistTransType: 514,
    RejectText: 1328,
    RelSymTransactTime: 1504,
    RepoCollateralSecurityType: 239,
    ReportToExch: 113,
    ReportedPx: 861,
    ReportedPxDiff: 1134,
    RepurchaseRate: 227,
    RepurchaseTerm: 226,
    ResetSeqNumFlag: 141,
    RespondentType: 1172,
    ResponseDestination: 726,
    ResponseTransportType: 725,
    RestructuringType: 1449,
    ReversalIndicator: 700,
    RiskFreeRate: 1190,
    RndPx: 991,
    RootPartyID: 1117,
    RootPartyIDSource: 1118,
    RootPartyRole: 1119,
    RootPartySubID: 1121,
    RootPartySubIDType: 1122,
    RoundLot: 561,
    RoundingDirection: 468,
    RoundingModulus: 469,
    RoutingID: 217,
    RoutingType: 216,
    RptSeq: 83,
    RptSys: 1135,
    Scope: 546,
    SecondaryAllocID: 793,
    SecondaryClOrdID: 526,
    SecondaryDisplayQty: 1082,
    SecondaryExecID: 527,
    SecondaryFirmTradeID: 1042,
    SecondaryHighLimitPrice: 1230,
    SecondaryIndividualAllocID: 989,
    SecondaryLowLimitPrice: 1221,
    SecondaryOrderID: 198,
    SecondaryPriceLimitType: 1305,
    SecondaryTradeID: 1040,
    SecondaryTradeReportID: 818,
    SecondaryTradeReportRefID: 881,
    SecondaryTradingReferencePrice: 1240,
    SecondaryTrdType: 855,
    SecureData: 91,
    SecureDataLen: 90,
    SecurityAltID: 455,
    SecurityAltIDSource: 456,
    SecurityDesc: 107,
    SecurityExchange: 207,
    SecurityGroup: 1151,
    SecurityID: 48,
    SecurityIDSource: 22,
    SecurityListDesc: 1467,
    SecurityListID: 1465,
    SecurityListRefID: 1466,
    SecurityListRequestType: 559,
    SecurityListType: 1470,
    SecurityListTypeSource: 1471,
    SecurityReportID: 964,
    SecurityReqID: 320,
    SecurityRequestResult: 560,
    SecurityRequestType: 321,
    SecurityResponseID: 322,
    SecurityResponseType: 323,
    SecurityStatus: 965,
    SecurityStatusReqID: 324,
    SecuritySubType: 762,
    SecurityTradingEvent: 1174,
    SecurityTradingStatus: 326,
    SecurityType: 167,
    SecurityUpdateAction: 980,
    SecurityXML: 1185,
    SecurityXMLLen: 1184,
    SecurityXMLSchema: 1186,
    SellVolume: 331,
    SellerDays: 287,
    SenderCompID: 49,
    SenderLocationID: 142,
    SenderSubID: 50,
    SendingTime: 52,
    Seniority: 1450,
    SessionRejectReason: 373,
    SettlCurrAmt: 119,
    SettlCurrBidFxRate: 656,
    SettlCurrFxRate: 155,
    SettlCurrFxRateCalc: 156,
    SettlCurrOfferFxRate: 657,
    SettlCurrency: 120,
    SettlDate: 64,
    SettlDate2: 193,
    SettlDeliveryType: 172,
    SettlInstID: 162,
    SettlInstMode: 160,
    SettlInstMsgID: 777,
    SettlInstRefID: 214,
    SettlInstReqID: 791,
    SettlInstReqRejCode: 792,
    SettlInstSource: 165,
    SettlInstTransType: 163,
    SettlMethod: 1193,
    SettlObligID: 1161,
    SettlObligMode: 1159,
    SettlObligMsgID: 1160,
    SettlObligRefID: 1163,
    SettlObligSource: 1164,
    SettlObligTransType: 1162,
    SettlPartyID: 782,
    SettlPartyIDSource: 783,
    SettlPartyRole: 784,
    SettlPartySubID: 785,
    SettlPartySubIDType: 786,
    SettlPrice: 730,
    SettlPriceType: 731,
    SettlSessID: 716,
    SettlSessSubID: 717,
    SettlType: 63,
    SettleOnOpenFlag: 966,
    SettlementCycleNo: 1153,
    SharedCommission: 858,
    ShortQty: 705,
    ShortSaleReason: 853,
    Side: 54,
    SideComplianceID: 659,
    SideCurrency: 1154,
    SideExecID: 1427,
    SideFillStationCd: 1006,
    SideGrossTradeAmt: 1072,
    SideLastQty: 1009,
    SideLiquidityInd: 1444,
    SideMultiLegReportingType: 752,
    SideReasonCd: 1007,
    SideSettlCurrency: 1155,
    SideTimeInForce: 962,
    SideTradeReportID: 1005,
    SideTrdRegTimestamp: 1012,
    SideTrdRegTimestampSrc: 1014,
    SideTrdRegTimestampType: 1013,
    SideTrdSubTyp: 1008,
    SideValue1: 396,
    SideValue2: 397,
    SideValueInd: 401,
    Signature: 89,
    SignatureLength: 93,
    SolicitedFlag: 377,
    Spread: 218,
    StandInstDbID: 171,
    StandInstDbName: 170,
    StandInstDbType: 169,
    StartCash: 921,
    StartDate: 916,
    StartMaturityMonthYear: 1241,
    StartStrikePxRange: 1202,
    StartTickPriceRange: 1206,
    StateOrProvinceOfIssue: 471,
    StatsType: 1176,
    StatusText: 929,
    StatusValue: 928,
    StipulationType: 233,
    StipulationValue: 234,
    StopPx: 99,
    StrategyParameterName: 958,
    StrategyParameterType: 959,
    StrategyParameterValue: 960,
    StreamAsgnAckType: 1503,
    StreamAsgnRejReason: 1502,
    StreamAsgnReqID: 1497,
    StreamAsgnReqType: 1498,
    StreamAsgnRptID: 1501,
    StreamAsgnType: 1617,
    StrikeCurrency: 947,
    StrikeExerciseStyle: 1304,
    StrikeIncrement: 1204,
    StrikeMultiplier: 967,
    StrikePrice: 202,
    StrikePriceBoundaryMethod: 1479,
    StrikePriceBoundaryPrecision: 1480,
    StrikePriceDeterminationMethod: 1478,
    StrikeRuleID: 1223,
    StrikeTime: 443,
    StrikeValue: 968,
    Subject: 147,
    SubscriptionRequestType: 263,
    SwapPoints: 1069,
    Symbol: 55,
    SymbolSfx: 65,
    TZTransactTime: 1132,
    TargetCompID: 56,
    TargetLocationID: 143,
    TargetPartyID: 1462,
    TargetPartyIDSource: 1463,
    TargetPartyRole: 1464,
    TargetStrategy: 847,
    TargetStrategyParameters: 848,
    TargetStrategyPerformance: 850,
    TargetSubID: 57,
    TaxAdvantageType: 495,
    TerminationType: 788,
    TestMessageIndicator: 464,
    TestReqID: 112,
    Text: 58,
    ThresholdAmount: 834,
    TickDirection: 274,
    TickIncrement: 1208,
    TickRuleType: 1209,
    TierCode: 994,
    TimeBracket: 943,
    TimeInForce: 59,
    TimeToExpiration: 1189,
    TimeUnit: 997,
    TotNoAccQuotes: 1169,
    TotNoAllocs: 892,
    TotNoCxldQuotes: 1168,
    TotNoFills: 1361,
    TotNoOrders: 68,
    TotNoQuoteEntries: 304,
    TotNoRejQuotes: 1170,
    TotNoRelatedSym: 393,
    TotNoSecurityTypes: 557,
    TotNoStrikes: 422,
    TotNumAssignmentReports: 832,
    TotNumReports: 911,
    TotNumTradeReports: 748,
    TotalAccruedInterestAmt: 540,
    TotalAffectedOrders: 533,
    TotalNetValue: 900,
    TotalNumPosReports: 727,
    TotalTakedown: 237,
    TotalVolumeTraded: 387,
    TradSesCloseTime: 344,
    TradSesEndTime: 345,
    TradSesEvent: 1368,
    TradSesMethod: 338,
    TradSesMode: 339,
    TradSesOpenTime: 342,
    TradSesPreCloseTime: 343,
    TradSesReqID: 335,
    TradSesStartTime: 341,
    TradSesStatus: 340,
    TradSesStatusRejReason: 567,
    TradSesUpdateAction: 1327,
    TradeAllocIndicator: 826,
    TradeCondition: 277,
    TradeDate: 75,
    TradeHandlingInstr: 1123,
    TradeID: 1003,
    TradeInputDevice: 579,
    TradeInputSource: 578,
    TradeLegRefID: 824,
    TradeLinkID: 820,
    TradeOriginationDate: 229,
    TradePublishIndicator: 1390,
    TradeReportID: 571,
    TradeReportRefID: 572,
    TradeReportRejectReason: 751,
    TradeReportTransType: 487,
    TradeReportType: 856,
    TradeRequestID: 568,
    TradeRequestResult: 749,
    TradeRequestStatus: 750,
    TradeRequestType: 569,
    TradeVolume: 1020,
    TradedFlatSwitch: 258,
    TradingCurrency: 1245,
    TradingReferencePrice: 1150,
    TradingSessionDesc: 1326,
    TradingSessionID: 336,
    TradingSessionSubID: 625,
    TransBkdTime: 483,
    TransactTime: 60,
    TransferReason: 830,
    TrdMatchID: 880,
    TrdRegTimestamp: 769,
    TrdRegTimestampOrigin: 771,
    TrdRegTimestampType: 770,
    TrdRepIndicator: 1389,
    TrdRepPartyRole: 1388,
    TrdRptStatus: 939,
    TrdSubType: 829,
    TrdType: 828,
    TriggerAction: 1101,
    TriggerNewPrice: 1110,
    TriggerNewQty: 1112,
    TriggerOrderType: 1111,
    TriggerPrice: 1102,
    TriggerPriceDirection: 1109,
    TriggerPriceType: 1107,
    TriggerPriceTypeScope: 1108,
    TriggerSecurityDesc: 1106,
    TriggerSecurityID: 1104,
    TriggerSecurityIDSource: 1105,
    TriggerSymbol: 1103,
    TriggerTradingSessionID: 1113,
    TriggerTradingSessionSubID: 1114,
    TriggerType: 1100,
    URLLink: 149,
    UnderlyingAdjustedQuantity: 1044,
    UnderlyingAllocationPercent: 972,
    UnderlyingAttachmentPoint: 1459,
    UnderlyingCFICode: 463,
    UnderlyingCPProgram: 877,
    UnderlyingCPRegType: 878,
    UnderlyingCapValue: 1038,
    UnderlyingCashAmount: 973,
    UnderlyingCashType: 974,
    UnderlyingCollectAmount: 986,
    UnderlyingContractMultiplier: 436,
    UnderlyingContractMultiplierUnit: 1437,
    UnderlyingCountryOfIssue: 592,
    UnderlyingCouponPaymentDate: 241,
    UnderlyingCouponRate: 435,
    UnderlyingCreditRating: 256,
    UnderlyingCurrency: 318,
    UnderlyingCurrentValue: 885,
    UnderlyingDeliveryAmount: 1037,
    UnderlyingDetachmentPoint: 1460,
    UnderlyingDirtyPrice: 882,
    UnderlyingEndPrice: 883,
    UnderlyingEndValue: 886,
    UnderlyingExerciseStyle: 1419,
    UnderlyingFXRate: 1045,
    UnderlyingFXRateCalc: 1046,
    UnderlyingFactor: 246,
    UnderlyingFlowScheduleType: 1441,
    UnderlyingInstrRegistry: 595,
    UnderlyingInstrumentPartyID: 1059,
    UnderlyingInstrumentPartyIDSource: 1060,
    UnderlyingInstrumentPartyRole: 1061,
    UnderlyingInstrumentPartySubID: 1063,
    UnderlyingInstrumentPartySubIDType: 1064,
    UnderlyingIssueDate: 242,
    UnderlyingIssuer: 306,
    UnderlyingLastPx: 651,
    UnderlyingLastQty: 652,
    UnderlyingLegCFICode: 1344,
    UnderlyingLegMaturityDate: 1345,
    UnderlyingLegMaturityMonthYear: 1339,
    UnderlyingLegMaturityTime: 1405,
    UnderlyingLegOptAttribute: 1391,
    UnderlyingLegPutOrCall: 1343,
    UnderlyingLegSecurityAltID: 1335,
    UnderlyingLegSecurityAltIDSource: 1336,
    UnderlyingLegSecurityDesc: 1392,
    UnderlyingLegSecurityExchange: 1341,
    UnderlyingLegSecurityID: 1332,
    UnderlyingLegSecurityIDSource: 1333,
    UnderlyingLegSecuritySubType: 1338,
    UnderlyingLegSecurityType: 1337,
    UnderlyingLegStrikePrice: 1340,
    UnderlyingLegSymbol: 1330,
    UnderlyingLegSymbolSfx: 1331,
    UnderlyingLocaleOfIssue: 594,
    UnderlyingMaturityDate: 542,
    UnderlyingMaturityMonthYear: 313,
    UnderlyingMaturityTime: 1213,
    UnderlyingNotionalPercentageOutstanding: 1455,
    UnderlyingOptAttribute: 317,
    UnderlyingOriginalNotionalPercentageOutstanding: 1456,
    UnderlyingPayAmount: 985,
    UnderlyingPriceDeterminationMethod: 1481,
    UnderlyingPriceUnitOfMeasure: 1424,
    UnderlyingPriceUnitOfMeasureQty: 1425,
    UnderlyingProduct: 462,
    UnderlyingPutOrCall: 315,
    UnderlyingPx: 810,
    UnderlyingQty: 879,
    UnderlyingRedemptionDate: 247,
    UnderlyingRepoCollateralSecurityType: 243,
    UnderlyingRepurchaseRate: 245,
    UnderlyingRepurchaseTerm: 244,
    UnderlyingRestructuringType: 1453,
    UnderlyingSecurityAltID: 458,
    UnderlyingSecurityAltIDSource: 459,
    UnderlyingSecurityDesc: 307,
    UnderlyingSecurityExchange: 308,
    UnderlyingSecurityID: 309,
    UnderlyingSecurityIDSource: 305,
    UnderlyingSecuritySubType: 763,
    UnderlyingSecurityType: 310,
    UnderlyingSeniority: 1454,
    UnderlyingSettlMethod: 1039,
    UnderlyingSettlPrice: 732,
    UnderlyingSettlPriceType: 733,
    UnderlyingSettlementDate: 987,
    UnderlyingSettlementStatus: 988,
    UnderlyingSettlementType: 975,
    UnderlyingStartValue: 884,
    UnderlyingStateOrProvinceOfIssue: 593,
    UnderlyingStipType: 888,
    UnderlyingStipValue: 889,
    UnderlyingStrikeCurrency: 941,
    UnderlyingStrikePrice: 316,
    UnderlyingSymbol: 311,
    UnderlyingSymbolSfx: 312,
    UnderlyingTimeUnit: 1000,
    UnderlyingTradingSessionID: 822,
    UnderlyingTradingSessionSubID: 823,
    UnderlyingUnitOfMeasure: 998,
    UnderlyingUnitOfMeasureQty: 1423,
    UnitOfMeasure: 996,
    UnitOfMeasureQty: 1147,
    UnsolicitedIndicator: 325,
    Urgency: 61,
    UserRequestID: 923,
    UserRequestType: 924,
    UserStatus: 926,
    UserStatusText: 927,
    Username: 553,
    ValidUntilTime: 62,
    ValuationMethod: 1197,
    ValueOfFutures: 408,
    VenueType: 1430,
    Volatility: 1188,
    WorkingIndicator: 636,
    WtAverageLiquidity: 410,
    XmlData: 213,
    XmlDataLen: 212,
    Yield: 236,
    YieldCalcDate: 701,
    YieldRedemptionDate: 696,
    YieldRedemptionPrice: 697,
    YieldRedemptionPriceType: 698,
    YieldType: 235
}

export default fieldManifest
